import { render, staticRenderFns } from "./mapIssue.vue?vue&type=template&id=8f3784be&scoped=true&lang=pug"
import script from "./mapIssue.vue?vue&type=script&lang=js"
export * from "./mapIssue.vue?vue&type=script&lang=js"
import style0 from "./mapIssue.vue?vue&type=style&index=0&id=8f3784be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3784be",
  null
  
)

export default component.exports